import { Order } from '@spike/order-model';

export const isOrderInRecurringSeries = (order: Order | undefined): boolean =>
    order?.items.appointments.some(item => item.appointment.recurringSeriesId != null) ?? false;
